export const formatNumber = (value: number) => {
  return new Intl.NumberFormat('fr-FR').format(value)
}

export const formatDate = (value: unknown) => {
  if (typeof value !== 'string' || !value) {
    return '-'
  }

  const date = new Date(value)

  if (Number.isNaN(date.getTime())) {
    return '-'
  }

  return new Intl.DateTimeFormat('fr-FR', {
    dateStyle: 'short',
    timeStyle: 'short'
  }).format(date)
}

export const getStringValue = (value: unknown) => {
  return typeof value === 'string' ? value : ''
}
